import type { ReactNode } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { motionSafe, springDefault, springExit } from '@/lib/motion';

/**
 * Height-animated disclosure.
 *
 * Spring rather than a CSS height transition: a toggle interrupted mid-flight
 * resumes from the height actually on screen instead of snapping to the start
 * of a new transition.
 */
export function Collapse({ open, children }: { open: boolean; children: ReactNode }) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={motionSafe(open ? springDefault : springExit)}
          className="overflow-hidden"
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
